import { createContext, useContext } from 'react';
import { DropdownContextType } from './types';

const DropdownContext = createContext<DropdownContextType<any> | null>(null);

/**
 * Custom hook to consume the Dropdown Context with type safety.
 */
export const useDropdownContext = <T extends string | number>() => {
  const context = useContext(DropdownContext);
  if (!context) throw new Error('useDropdownContext must be used within a DropdownProvider');
  return context as DropdownContextType<T>;
};

export default DropdownContext;